import styles from './PropertySpyCard.module.css'
import { Box, Button, Card, CardActions, CardContent, CardHeader, List, ListItem, Stack } from '@mui/material'
import { Link } from 'react-router-dom'
import { PropertySpyFromResponse } from 'shared/types/PropertySpyFromResponse'
import { useStopSpyHostServiceMutation } from 'services/propertySpy'
import { useSetMineHostServiceMutation } from 'services/hostService'
import { useSetHostServiceNotMineMutation } from 'services/hostService'
import { WarningIcon } from 'shared/icons/WarningIcon'

interface PropertySpyCardProps {
    propertySpy: PropertySpyFromResponse
}

export const PropertySpyCard = (props: PropertySpyCardProps): JSX.Element => {
    const {
        propertySpy
    } = props

    const [stopSpyHostService] = useStopSpyHostServiceMutation()
    const [setMineHostService] = useSetMineHostServiceMutation()
    const [setNotMineHostService] = useSetHostServiceNotMineMutation()

    const renderPicture = () => {
        return (
        <Box
            component="img"
            sx={{
                width: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'cover',
                height: '320px'
            }}
            alt=""
                src={propertySpy?.strHostServicePicture}>
            </Box>
        )
    }

    const handleStopSpy = async () => {
        await stopSpyHostService({
            hostServiceId: propertySpy.strHostServiceId,
            marketSpyId: propertySpy.strMonitorId
        })
    }

    const handleItsMine = async () => {
        if (propertySpy.isOwn) {
            await setNotMineHostService({
                hostServiceId: propertySpy.strHostServiceId
            })

            return
        } 

        await setMineHostService({
            hostServiceId: propertySpy.strHostServiceId
        })
    }

    const renderNewChangesIndicator = () => {
        if (propertySpy?.newChanges === true) {
            return (
                <WarningIcon sx={{ color: '#FFF', fontSize: '42px' }} />
            )
        }

        return (
            ``
        )
    }

    return (

         <>
            <Card sx={{
                maxWidth: 420,
                minWidth: 420,
                minHeight: 460,
                '& .MuiCardHeader-content': {
                    padding: '0 0 0 0',
                },
                '& ': {
                    color: '#FFF',
                    display: 'flex',
                    flexDirection: 'column'
                },
                '& .MuiCardHeader-root': {
                    padding: '16px 16px 0 16px',
                    backgroundColor: '#1e1e1e',
                },
                '& .MuiCardContent-root': {
                    backgroundColor: '#1e1e1e',
                    flexGrow: 1,
                    display: 'flex'
                },
                '& .MuiList-root': {
                    backgroundColor: '#1e1e1e',
                },
                '& .MuiCardActions-root': {
                    backgroundColor: '#1e1e1e',
                },
                '&.isMine .MuiSvgIcon-root': {
                    color: '#FFF'
                },             
                  
            }}>
                <CardHeader
                    title={
                        <Box sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
            
                            height: '48px',
                            maxHeight: '48px',
                            fontWeight: '600', fontSize: '18px', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical',
                            wordBreak: `break-all`,
                            display: 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <div>{propertySpy?.strHostServiceName}</div>
                            <div className={styles.PropertySpyCard_WarninIconContainer }>
                                {
                                    renderNewChangesIndicator()
                                }
                            </div>
                        </Box>
                    }
                 
                />

                <CardContent sx={{ p: 0 }}>
                    <List sx={{ width: '100%', maxWidth: 420, bgcolor: 'background.paper', py: '6px', display: 'flex' }}>
                        <ListItem key="picture" sx={{ flexGrow: 1, position: 'relative' }}>
                            <div className={styles.PropertySpyCard_Content}>
                                <div className={styles.PropertySpyCard_StatusToolbarContainer}>
                                    <div className={styles.PropertySpyCard_StatusToolbar}>
                                        <Box sx={{ padding: '6px 6px', backgroundColor: '#ffee33', display: 'flex', justifyContent: `space-between` }}>
                                            <Box sx={{ alignItems: `center`, display: `flex`, fontSize: '20px', fontWeight: 700, color: '#000', minWidth: '150px' }}>
                                                <Box component="span">Position:</Box>
                                                <Box component="span" sx={{ fontWeight: 400, marginLeft: '4px' }}>{propertySpy.hostRank ? propertySpy.hostRank : ''}</Box>
                                            </Box>

                                            <Button
                                                color="success"
                                                variant="contained"
                                                sx={{
                                                    minWidth: 160,
                                                    minHeight: 48,
                                                    fontSize: '20px',
                                                    textTransform: 'none'
                                                }}
                                                onClick={handleItsMine}
                                            >
                                                {propertySpy.isOwn ? `Not mine` : `Claim it`}
                                            </Button >
                                        </Box>
                                    </div>
                                </div> 

                                {
                                    renderPicture()
                                }    
                            </div>
                        </ListItem>
                    </List>                 
                </CardContent>
                <CardActions sx={{ p: 0 }}>
                    <Box sx={{ width: '100%' }}>
                      
                        <Stack direction="row" spacing={''} sx={{ p: '8px', justifyContent: "space-between", }}>
                            <Link to={`/propertyspy/${propertySpy.id}`}>
                                <Button
                                    color="success"
                                    variant="contained"
                                    sx={{
                                        minWidth: 160,
                                        minHeight: 48,
                                        fontSize: '20px',
                                        textTransform: 'none'
                                    }}
                                >
                                    Details
                                </Button >
                            </Link>
                            <Button
                                color="success"
                                variant="outlined"
                                onClick={handleStopSpy}
                                sx={{
                                    minWidth: 160,
                                    minHeight: 48,
                                    fontSize: '20px',
                                    textTransform: 'none',
                                    borderWidth: '2px!important',
                                    background: `#FFFF`
                                }}
                            >
                                Stop spy
                            </Button >
                        </Stack>
                    </Box>
                </CardActions>
            </Card>
         </>
    )
}